(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("amc-status-import", {
                parent: "admin",
                url: "/amc-status-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/amc-status-import/amc-status-import.html",
                        controller: "AmcImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            }).state("asset-availability-import", {
                parent: "admin",
                url: "/asset-availability-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/amc-status-import/asset-availability-import.html",
                        controller: "AssetAvailabilityImport",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })
        }
    })();